enum CustomerPlanEnum {
  SelfServe = "SELF_SERVE",
  Platform = "PLATFORM",
}

export default CustomerPlanEnum;
